import styled from 'styled-components';
import { TimerIcon } from '../assets';
import Typography from '../typography/Typography';
export const TimerContainer = styled.div `
  min-width: 12rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem 0.8rem 0.4rem 2.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.highM};

  background-color: ${({ theme, isCritical }) => isCritical
    ? theme.colors.interactive.critical
    : theme.colors.interactive.brandColor};
`;
export const TimerText = styled(Typography) `
  margin-left: 0.4rem;
`;
export const CustomTimerIcon = styled(TimerIcon) `
  position: absolute;
  left: 0.8rem;
`;
//# sourceMappingURL=styles.js.map